import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import WizardStepGroup from '../../../../WizardStepGroup';
import { EitherLearningCollectionStore } from '../../../Types';
import UtilizationBanner from '../../LearningCollectionSteps/UtilizationBanner';

interface Props {
  children?: React.ReactNode;
  store: EitherLearningCollectionStore;
}

const Navigation: React.FC<Props> = ({ children, store }) => {
  return (
    <>
      <div className="top-16 z-10 w-full border-y border-gray-200 bg-white lg:top-24">
        <div
          className={clsx(
            'mx-auto flex max-w-clientPortalMaxWidth justify-end',
            'px-2.5 py-4 md:flex-row lg:px-12',
            'flex items-center justify-between',
          )}
        >
          <WizardStepGroup store={store} />
          <div>{children}</div>
        </div>
      </div>
      <div className="flex flex-row py-2 min-h-[3rem] justify-center items-center w-full my-auto border-b border-gray-20 bg-teal-600 bg-opacity-5">
        <UtilizationBanner store={store} placementProps={{ position: { top: 'top-[14.5rem]' } }} />
      </div>
    </>
  );
};

export default observer(Navigation);
